import React, { useMemo } from "react";
import { Loader } from "components/Loader";
import { TableSection } from "features/Research/v2/components/StockDetailPage/StockDetailPage.styles";
import { Text } from "style/v2/components/Typography";
import {
  Card,
  CardHeader,
  CardContent,
} from "../TopHoldings/TopHoldings.styles";
import { columns } from "./columns";
import PropTypes from "prop-types";
import { getStockCompanyIcon } from "utils/index";
import { Table } from "components/Table";

const toMap = (arr) =>
  Object.fromEntries((arr || []).map(({ name, value }) => [name, value]));

const TopHoldingsDetail = ({
  holdings30d,
  holdingsAverage,
  holdingsCurrent,
  isLoading,
}) => {
  const { holdings, hasData } = useMemo(() => {
    const map30d = toMap(holdings30d);
    const mapAverage = toMap(holdingsAverage);
    const mapCurrent = toMap(holdingsCurrent);

    const allNames = [
      ...new Set([
        ...Object.keys(map30d),
        ...Object.keys(mapAverage),
        ...Object.keys(mapCurrent),
      ]),
    ];

    const result = allNames.map((name) => ({
      id: name,
      asset: {
        symbol: name,
        imageUrl: getStockCompanyIcon(name),
      },
      holdings30d: map30d[name] ?? null,
      holdingsAverage: mapAverage[name] ?? null,
      holdingsCurrent: mapCurrent[name] ?? null,
    }));

    return {
      holdings: result,
      hasData: result.some(
        (h) =>
          h.holdings30d != null ||
          h.holdingsAverage != null ||
          h.holdingsCurrent != null
      ),
    };
  }, [holdings30d, holdingsAverage, holdingsCurrent]);

  if (isLoading) {
    return (
      <Card>
        <CardContent>
          <Loader />
        </CardContent>
      </Card>
    );
  }

  if (!hasData) return null;

  return (
    <TableSection>
      <Card>
        <CardHeader>
          <Text variant="cardHeading" weight="500" as="h3">
            Top Holdings Allocations
          </Text>
        </CardHeader>
        <CardContent>
          <Table
            data={holdings}
            columns={columns}
            isLoading={isLoading}
            notFoundText="No holdings data available"
            showPagination={false}
          />
        </CardContent>
      </Card>
    </TableSection>
  );
};

TopHoldingsDetail.propTypes = {
  holdings30d: PropTypes.array,
  holdingsAverage: PropTypes.array,
  holdingsCurrent: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default TopHoldingsDetail;
